export interface Country {
  code: string;     // ISO 3166-1 alpha-2  ex: 'MA'
  dialCode: string; // sans + ni 00        ex: '212'
  flag: string;     // emoji drapeau
  name: { ar: string; fr: string; en: string };
}

export const COUNTRIES: Country[] = [
  { code: 'MA', dialCode: '212', flag: '🇲🇦', name: { ar: 'المغرب',          fr: 'Maroc',           en: 'Morocco'       } },
  { code: 'DZ', dialCode: '213', flag: '🇩🇿', name: { ar: 'الجزائر',         fr: 'Algérie',         en: 'Algeria'       } },
  { code: 'TN', dialCode: '216', flag: '🇹🇳', name: { ar: 'تونس',            fr: 'Tunisie',         en: 'Tunisia'       } },
  { code: 'LY', dialCode: '218', flag: '🇱🇾', name: { ar: 'ليبيا',           fr: 'Libye',           en: 'Libya'         } },
  { code: 'MR', dialCode: '222', flag: '🇲🇷', name: { ar: 'موريتانيا',       fr: 'Mauritanie',      en: 'Mauritania'    } },
  { code: 'EG', dialCode: '20',  flag: '🇪🇬', name: { ar: 'مصر',             fr: 'Égypte',          en: 'Egypt'         } },
  { code: 'SA', dialCode: '966', flag: '🇸🇦', name: { ar: 'السعودية',        fr: 'Arabie Saoudite', en: 'Saudi Arabia'  } },
  { code: 'AE', dialCode: '971', flag: '🇦🇪', name: { ar: 'الإمارات',        fr: 'Émirats arabes',  en: 'UAE'           } },
  { code: 'QA', dialCode: '974', flag: '🇶🇦', name: { ar: 'قطر',             fr: 'Qatar',           en: 'Qatar'         } },
  { code: 'KW', dialCode: '965', flag: '🇰🇼', name: { ar: 'الكويت',          fr: 'Koweït',          en: 'Kuwait'        } },
  { code: 'FR', dialCode: '33',  flag: '🇫🇷', name: { ar: 'فرنسا',           fr: 'France',          en: 'France'        } },
  { code: 'BE', dialCode: '32',  flag: '🇧🇪', name: { ar: 'بلجيكا',          fr: 'Belgique',        en: 'Belgium'       } },
  { code: 'ES', dialCode: '34',  flag: '🇪🇸', name: { ar: 'إسبانيا',         fr: 'Espagne',         en: 'Spain'         } },
  { code: 'IT', dialCode: '39',  flag: '🇮🇹', name: { ar: 'إيطاليا',         fr: 'Italie',          en: 'Italy'         } },
  { code: 'NL', dialCode: '31',  flag: '🇳🇱', name: { ar: 'هولندا',          fr: 'Pays-Bas',        en: 'Netherlands'   } },
  { code: 'DE', dialCode: '49',  flag: '🇩🇪', name: { ar: 'ألمانيا',         fr: 'Allemagne',       en: 'Germany'       } },
  { code: 'GB', dialCode: '44',  flag: '🇬🇧', name: { ar: 'المملكة المتحدة', fr: 'Royaume-Uni',     en: 'UK'            } },
  { code: 'CH', dialCode: '41',  flag: '🇨🇭', name: { ar: 'سويسرا',          fr: 'Suisse',          en: 'Switzerland'   } },
  { code: 'PT', dialCode: '351', flag: '🇵🇹', name: { ar: 'البرتغال',         fr: 'Portugal',        en: 'Portugal'      } },
  { code: 'SE', dialCode: '46',  flag: '🇸🇪', name: { ar: 'السويد',           fr: 'Suède',           en: 'Sweden'        } },
  { code: 'AT', dialCode: '43',  flag: '🇦🇹', name: { ar: 'النمسا',           fr: 'Autriche',        en: 'Austria'       } },
  { code: 'CA', dialCode: '1',   flag: '🇨🇦', name: { ar: 'كندا',            fr: 'Canada',          en: 'Canada'        } },
  { code: 'US', dialCode: '1',   flag: '🇺🇸', name: { ar: 'أمريكا',          fr: 'États-Unis',      en: 'USA'           } },
  { code: 'TR', dialCode: '90',  flag: '🇹🇷', name: { ar: 'تركيا',           fr: 'Turquie',         en: 'Turkey'        } },
  { code: 'SN', dialCode: '221', flag: '🇸🇳', name: { ar: 'السنغال',         fr: 'Sénégal',         en: 'Senegal'       } },
  { code: 'ML', dialCode: '223', flag: '🇲🇱', name: { ar: 'مالي',            fr: 'Mali',            en: 'Mali'          } },
  // ── Monde arabe ──
  { code: 'JO', dialCode: '962', flag: '🇯🇴', name: { ar: 'الأردن',          fr: 'Jordanie',        en: 'Jordan'        } },
  { code: 'LB', dialCode: '961', flag: '🇱🇧', name: { ar: 'لبنان',           fr: 'Liban',           en: 'Lebanon'       } },
  { code: 'SY', dialCode: '963', flag: '🇸🇾', name: { ar: 'سوريا',           fr: 'Syrie',           en: 'Syria'         } },
  { code: 'IQ', dialCode: '964', flag: '🇮🇶', name: { ar: 'العراق',          fr: 'Irak',            en: 'Iraq'          } },
  { code: 'YE', dialCode: '967', flag: '🇾🇪', name: { ar: 'اليمن',           fr: 'Yémen',           en: 'Yemen'         } },
  { code: 'OM', dialCode: '968', flag: '🇴🇲', name: { ar: 'عُمان',           fr: 'Oman',            en: 'Oman'          } },
  { code: 'BH', dialCode: '973', flag: '🇧🇭', name: { ar: 'البحرين',         fr: 'Bahreïn',         en: 'Bahrain'       } },
  { code: 'PS', dialCode: '970', flag: '🇵🇸', name: { ar: 'فلسطين',          fr: 'Palestine',       en: 'Palestine'     } },
  { code: 'SD', dialCode: '249', flag: '🇸🇩', name: { ar: 'السودان',         fr: 'Soudan',          en: 'Sudan'         } },
  { code: 'SO', dialCode: '252', flag: '🇸🇴', name: { ar: 'الصومال',         fr: 'Somalie',         en: 'Somalia'       } },
  { code: 'KM', dialCode: '269', flag: '🇰🇲', name: { ar: 'جزر القمر',       fr: 'Comores',         en: 'Comoros'       } },
  { code: 'DJ', dialCode: '253', flag: '🇩🇯', name: { ar: 'جيبوتي',          fr: 'Djibouti',        en: 'Djibouti'      } },
  // ── Afrique subsaharienne ──
  { code: 'NE', dialCode: '227', flag: '🇳🇪', name: { ar: 'النيجر',          fr: 'Niger',           en: 'Niger'         } },
  { code: 'TD', dialCode: '235', flag: '🇹🇩', name: { ar: 'تشاد',            fr: 'Tchad',           en: 'Chad'          } },
  { code: 'GN', dialCode: '224', flag: '🇬🇳', name: { ar: 'غينيا',           fr: 'Guinée',          en: 'Guinea'        } },
  { code: 'GM', dialCode: '220', flag: '🇬🇲', name: { ar: 'غامبيا',          fr: 'Gambie',          en: 'Gambia'        } },
  { code: 'BF', dialCode: '226', flag: '🇧🇫', name: { ar: 'بوركينا فاسو',    fr: 'Burkina Faso',    en: 'Burkina Faso'  } },
  { code: 'CI', dialCode: '225', flag: '🇨🇮', name: { ar: 'كوت ديفوار',      fr: "Côte d'Ivoire",   en: 'Ivory Coast'   } },
  { code: 'NG', dialCode: '234', flag: '🇳🇬', name: { ar: 'نيجيريا',         fr: 'Nigeria',         en: 'Nigeria'       } },
  // ── Asie musulmane ──
  { code: 'PK', dialCode: '92',  flag: '🇵🇰', name: { ar: 'باكستان',         fr: 'Pakistan',        en: 'Pakistan'      } },
  { code: 'BD', dialCode: '880', flag: '🇧🇩', name: { ar: 'بنغلاديش',        fr: 'Bangladesh',      en: 'Bangladesh'    } },
  { code: 'ID', dialCode: '62',  flag: '🇮🇩', name: { ar: 'إندونيسيا',       fr: 'Indonésie',       en: 'Indonesia'     } },
  { code: 'MY', dialCode: '60',  flag: '🇲🇾', name: { ar: 'ماليزيا',         fr: 'Malaisie',        en: 'Malaysia'      } },
  // ── Europe ──
  { code: 'CH', dialCode: '41',  flag: '🇨🇭', name: { ar: 'سويسرا',          fr: 'Suisse',          en: 'Switzerland'   } },
  { code: 'PT', dialCode: '351', flag: '🇵🇹', name: { ar: 'البرتغال',        fr: 'Portugal',        en: 'Portugal'      } },
  { code: 'SE', dialCode: '46',  flag: '🇸🇪', name: { ar: 'السويد',          fr: 'Suède',           en: 'Sweden'        } },
  { code: 'AT', dialCode: '43',  flag: '🇦🇹', name: { ar: 'النمسا',          fr: 'Autriche',        en: 'Austria'       } },
];

export const DEFAULT_COUNTRY_CODE = 'MA';

export function getCountryByCode(code: string): Country {
  return COUNTRIES.find(c => c.code === code) ?? COUNTRIES[0];
}

export function getCountryByDialCode(dialCode: string): Country | undefined {
  return COUNTRIES.find(c => c.dialCode === dialCode);
}

/**
 * Formate un numéro local pour le stockage international.
 * Ex: '0612345678', pays=DZ, défaut=MA → '+213612345678'
 * Si même pays que le défaut → retourne le numéro nettoyé sans préfixe.
 */
export function formatPhoneForStorage(localNumber: string, country: Country, defaultCountry: Country): string {
  const cleaned = localNumber.replace(/[\s\-().]/g, '');
  if (country.code === defaultCountry.code) return cleaned;
  const withoutLeadingZero = cleaned.startsWith('0') ? cleaned.slice(1) : cleaned;
  return `+${country.dialCode}${withoutLeadingZero}`;
}

/**
 * Parse un numéro stocké : retourne le pays et le numéro local sans indicatif.
 * Ex: '+213612345678' → { country: DZ, localNumber: '0612345678' }
 * Ex: '0612345678'   → { country: defaultCountry, localNumber: '0612345678' }
 */
export function parseStoredPhone(
  stored: string,
  defaultCountry: Country,
): { country: Country; localNumber: string } {
  const cleaned = stored.replace(/[\s\-().]/g, '');
  const sorted = [...COUNTRIES].sort((a, b) => b.dialCode.length - a.dialCode.length);

  if (cleaned.startsWith('+') || cleaned.startsWith('00')) {
    const digits = cleaned.startsWith('00') ? cleaned.slice(2) : cleaned.slice(1);
    for (const c of sorted) {
      if (digits.startsWith(c.dialCode)) {
        return { country: c, localNumber: '0' + digits.slice(c.dialCode.length) };
      }
    }
  }
  if (cleaned.startsWith('0')) return { country: defaultCountry, localNumber: cleaned };

  for (const c of sorted) {
    if (cleaned.startsWith(c.dialCode) && cleaned.length > c.dialCode.length + 6) {
      return { country: c, localNumber: '0' + cleaned.slice(c.dialCode.length) };
    }
  }
  return { country: defaultCountry, localNumber: cleaned };
}

/**
 * Valide qu'un numéro contient au moins 8 chiffres (après nettoyage).
 */
export function isValidPhoneLength(phone: string): boolean {
  return phone.replace(/\D/g, '').length >= 8;
}

/**
 * Normalise un numéro pour WhatsApp (sans + ni 00).
 */
export function normalizeForWhatsApp(stored: string, selectedDialCode: string): string {
  const cleaned = stored.replace(/[\s\-().]/g, '');
  if (cleaned.startsWith('+'))  return cleaned.slice(1);
  if (cleaned.startsWith('00')) return cleaned.slice(2);
  const withoutZero = cleaned.startsWith('0') ? cleaned.slice(1) : cleaned;
  return `${selectedDialCode}${withoutZero}`;
}
